import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

export default function AlphaSort({ alphabetValue, setAlphabetValue }) {
  return (
    <Stack direction='row' sx={{ fontWeight: '900' }}>
      <Button
        variant='text'
        sx={
          alphabetValue === '1'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('1');
        }}
      >
        #
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'a'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('a');
        }}
      >
        A
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'b'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('b');
        }}
      >
        B
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'c'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('c');
        }}
      >
        C
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'd'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('d');
        }}
      >
        D
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'e'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('e');
        }}
      >
        E
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'f'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('f');
        }}
      >
        F
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'g'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('g');
        }}
      >
        G
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'h'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('h');
        }}
      >
        H
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'i'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('i');
        }}
      >
        I
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'j'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('j');
        }}
      >
        J
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'k'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('k');
        }}
      >
        K
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'l'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('l');
        }}
      >
        L
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'm'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('m');
        }}
      >
        M
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'n'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('n');
        }}
      >
        N
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'o'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('o');
        }}
      >
        O
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'p'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('p');
        }}
      >
        P
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'q'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('q');
        }}
      >
        Q
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'r'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('r');
        }}
      >
        R
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 's'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('s');
        }}
      >
        S
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 't'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('t');
        }}
      >
        T
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'u'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('u');
        }}
      >
        U
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'v'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('v');
        }}
      >
        V
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'w'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('w');
        }}
      >
        W
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'x'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('x');
        }}
      >
        X
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'y'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('y');
        }}
      >
        Y
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === 'z'
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('z');
        }}
      >
        Z
      </Button>
      <Button
        variant='text'
        sx={
          alphabetValue === ''
            ? {
                color: '#0066c0',
                textDecoration: 'underline',
                fontWeight: '900',
              }
            : { fontWeight: '900' }
        }
        onClick={(e) => {
          e.preventDefault();
          setAlphabetValue('');
        }}
      >
        All
      </Button>
    </Stack>
  );
}

AlphaSort.propTypes = {
  alphabetValue: PropTypes.string.isRequired,
  setAlphabetValue: PropTypes.func.isRequired,
};
